import BaseCommand from "@/models/api/commands/BaseCommand";

export class RefundBookingItemCommand extends BaseCommand {
  CommandName = "RefundBookingItem";
  Command: { BookingItemTmpId: string };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId };
  }
}
